// Source names
export const LM_SOURCE_ID = 'lm';
export const LM_SOURCE_LAYER_INDOOR_ID = 'indoor';
export const LM_SOURCE_LAYER_OUTDOOR_ID = 'outdoor';
export const CLUSTER_SOURCE_ID = 'pin';
export const MMS_PIN_SOURCE_ID = 'pin_mms';
export const MMS_PIN_SOURCE_LAYER_ID = 'pin_mms';
export const SELECTED_FEATURE_SOURCE_ID = 'selected_feature';
export const LIVE_LOCATION_SOURCE_AND_LAYER_ID = 'pin_user';

// Pin Types
export const PIN_TYPE_MMS = 'mms';
export const PIN_TYPE_FEATURE = 'feature';
export const PIN_TYPE_USER = 'user';

// Layer names
export const SELECTED_FEATURE_LAYER = 'highlight_pin'; // stylesheet naming
export const SEARCH_PIN_LAYER = 'search_pin';
export const SEARCH_CLUSTER_LAYER = 'search_badge_cluster';

// projection definition as can be found on https://epsg.io/27700
export const UK_27700_PROJECTION = `+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs`;

// projection definition as can be found on https://epsg.io/4326
export const MAPBOX_LATLON_PROJECTION = `+proj=longlat +datum=WGS84 +no_defs`;
